import type { InventoryItem } from 'src/types/itemInventory';

export const DEFAULT_ICON_URL = '/images/icons/imgSystemMessageDefault.png';

export const getChatEventItemCount = (
  inventoryItems: InventoryItem[] | null,
  categoryId: string
): number => {
  if (!inventoryItems) return 0;
  const item = inventoryItems.find((i) => i.categoryId === categoryId);
  return item?.quantity ?? 0;
};

export const getChatEventMessageKey = (type: string): { key: string; paramName: string } | null => {
  switch (type) {
    case 'GENDER_FILTER_COUNT':
      return { key: 'match.toast_left_gender', paramName: 'itemCount' };
    case 'SUPER_MATCH_FILTER_COUNT':
      return { key: 'match.toast_left_super', paramName: 'itemCount' };
    case 'AZAR_PICK_FILTER_COUNT':
      return { key: 'match.toast_left_pick', paramName: 'itemCount' };
    case 'LOCAL_GUARANTEE_COUNT':
      return { key: 'match.toast_left_domestic', paramName: 'itemCount' };
    case 'COUNTRY_GUARANTEE_FILTER_COUNT':
      return { key: 'match.toast_left_country', paramName: 'itemCount' };
    default:
      return null;
  }
};

export const getChatEventIcon = (type: string): string => {
  switch (type) {
    case 'GENDER_FILTER_COUNT':
      return '/images/item/imgGenderFilter.png';
    case 'SUPER_MATCH_FILTER_COUNT':
      return '/images/item/imgItemSuperMatch.png';
    case 'AZAR_PICK_FILTER_COUNT':
      return DEFAULT_ICON_URL;
    case 'LOCAL_GUARANTEE_COUNT':
      return '/images/item/imgItemCountry.png';
    case 'COUNTRY_GUARANTEE_FILTER_COUNT':
      return '/images/item/imgItemAzarGuarantee4.png';
    case 'FOLLOWING':
      return '/images/icons/imgPin.png';
    default:
      return DEFAULT_ICON_URL;
  }
};
